'use client';

import {
  CircularProgress,
  CircularProgressProps,
  Skeleton,
  SkeletonProps,
} from '@/primitives';
import { LinearProgress, LinearProgressProps } from '@mui/material';
import { ReactNode } from 'react';

type TProps = {
  isLoading: boolean;
  useCircularProgress?: boolean;
  useLinearProgress?: boolean;
  children: ReactNode | ReactNode[];
} & CircularProgressProps &
  LinearProgressProps &
  SkeletonProps;

export default function WithSkeleton({
  children,
  isLoading,
  useCircularProgress,
  useLinearProgress,
  ...props
}: TProps) {
  if (isLoading) {
    if (useCircularProgress)
      return <CircularProgress sx={{ display: 'block' }} {...props} />;
    if (useLinearProgress)
      return (
        <LinearProgress sx={{ width: '100%', display: 'block' }} {...props} />
      );
    return (
      <Skeleton sx={{ minWidth: 100 }} {...props}>
        {children}
      </Skeleton>
    );
  }
  return <>{children}</>;
}
